'use client'
import { type CSSProperties, memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'
import { SubSectionTitle } from '@/components/common/SubSectionTitle'

export interface VaultV2TableErrorProps {
  title: string
  tableHeight?: CSSProperties['height']
}

const VaultV2TableError = ({ title, tableHeight = '378px' }: VaultV2TableErrorProps) => {
  return (
    <div className="gap-sm flex flex-col">
      <SubSectionTitle>{title}</SubSectionTitle>
      <ErrorDataUnavailable minHeight={tableHeight} />
    </div>
  )
}

export default memo(VaultV2TableError)
